import { useQueryClient } from "@tanstack/react-query";
import { usePostHog } from "posthog-js/react";

import { toast } from "@/components/toast/toast-queue";
import apiClient from "@/lib/api/client";
import { shutdownIntercom } from "@/lib/intercom";

export function useHandleLogout() {
  const queryClient = useQueryClient();
  const posthog = usePostHog();

  return async function handleLogout(): Promise<void> {
    try {
      await apiClient.url("/auth/logout").post().res();
    } catch (error) {
      console.error("Error during logout:", error);
      toast.add(
        { title: "Logout failed, please try again", type: "error" },
        { timeout: 5000 },
      );
    }

    void queryClient.cancelQueries({ queryKey: ["user"] });
    queryClient.clear();
    shutdownIntercom();
    posthog?.reset();
    window.location.replace("/login");
  };
}
